import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import JournalTable from "./JournalTable";
import useAxios from "axios-hooks";
import DeleteJournalModal from "./DeleteJournalModal";
import { Spinner } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import ErrorComponent from '../../../Util/ErrorComponent';
import SuccessComponent from '../../../Util/SuccessComponent';

const JournalList = () => {
    const [selectedPromptId, setSelectedPromptId] = useState(undefined);
    const [selectedPromptTitle, setSelectedPromptTitle] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const history = useHistory();
    let { url } = useRouteMatch();

    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: journals, loading: journalsLoading }, refetchJournals] = useAxios("journal/promptsAudit");
    
    if (journalsLoading)
        return <Spinner className="absolute-center" label="Loading Journals..." />;

    return (
        <>
            {!journalsLoading && journals.length > 0 && (
            <>  
                <SuccessComponent
                    successMessage="Journal Deleted."
                    showSuccess={showSuccess}
                    setShowSuccess={setShowSuccess}
                />
                <ErrorComponent
                    errorMessage={errorMsg}
                    showError={showError}
                    setShowError={setShowError}
                />
                <JournalTable
                    journalTable={journals && journals.length > 0 ? journals.sort((a, b) => b.journalPromptId - a.journalPromptId) : []}
                    setSelectedPromptId={setSelectedPromptId}
                    setSelectedPromptTitle={setSelectedPromptTitle}
                    selectedPromptId={selectedPromptId}
                    createOnClick={() => history.push(`${url}/wizard`)}
                    deleteOnClick={(id, prompt) => {
                        setSelectedPromptId(id);
                        setSelectedPromptTitle(prompt || "");
                        toggleDeleteModal();
                    }}
                    editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                    refetch={refetchJournals}
                    loading={journalsLoading}
                />
                <DeleteJournalModal
                    promptId={selectedPromptId}
                    journalTitle={selectedPromptTitle}
                    showModal={showDeleteModal}
                    toggleShowModal={toggleDeleteModal}
                    onDelete={() => refetchJournals()}
                    setShowSuccess={setShowSuccess}
                    setShowError={setShowError}
                    setErrorMsg={setErrorMsg}
                />
            </>
            )}
        </>
    );
};

export default JournalList;
